import * as XLSX from 'xlsx';

export const DownloadBookings = (data) => {
    if (!Array.isArray(data) || data.length === 0) {
        alert('No data available to download!');
        return;
    }

    try {
        // Preprocess the data to include only 'name' and 'phone'
        const filteredData = data.map((item,index) => ({
            "SN": index+1,
            "Booking Date": new Date(item.createdAt).toLocaleString(),
            "Agency Name": item.agencyName,
            "Head Name": item.headName,
            "Members": item.totalMembers,
            "Price": item.totalPrice?.toLocaleString(),
            "Package": item.packageName,
        }));

        // Step 1: Convert JSON data to a worksheet
        const worksheet = XLSX.utils.json_to_sheet(filteredData);

        // Step 2: Create a workbook and append the worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Bookings');

        // Step 3: Export the workbook as an Excel file
        const fileName = 'Agencies Bookings.xlsx';
        XLSX.writeFile(workbook, fileName);
       
    } catch (error) {
        console.error('Error while exporting data to Excel:', error);
        alert('An error occurred while downloading the Excel file.');
    }
};
